import React from 'react';
import './Disclaimer.css';
import PixelIcon from './PixelIcon';

function Disclaimer() {
  return (
    <div className="disclaimer pixel-border-thin">
      <div className="disclaimer-content">
        <div className="disclaimer-icon"><PixelIcon name="warning" size={22} /></div>
        <div className="disclaimer-text">
          <p className="disclaimer-title text-cyan">DISCLAIMER / DICHIARAZIONE</p>
          <p className="disclaimer-body text-secondary">
            <strong className="text-white">EN:</strong> This project is NOT affiliated with any organization, 
            including AI2027 or any government. We are independent researchers with a curiosity 
            to recognize and monitor world events related to AI development.
          </p>
          <p className="disclaimer-body text-secondary">
            <strong className="text-white">IT:</strong> Questo progetto NON è affiliato con alcuna organizzazione, 
            incluso AI2027 o qualsiasi governo. Siamo ricercatori indipendenti con la curiosità 
            di riconoscere e monitorare gli eventi mondiali relativi allo sviluppo dell'IA.
          </p>
          <p className="disclaimer-note text-secondary">
            This is a monitoring and visualization tool based on a theoretical analytical model. 
            Data shown is for informational purposes and should not be used as the sole basis 
            for decision-making about AI policy or safety.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Disclaimer;
